import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _excluded = ["inputRef", "screenReaderText", "onRemoveChoice"];
var _dec, _class, _ChoiceInput;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import striptags from 'striptags';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import { jsx } from '@instructure/emotion';
import { View } from '@instructure/ui-view';
import { Grid } from '@instructure/ui-grid';
import { withStyleOverrides, Flex } from '@instructure/quiz-common';
import { RichContentInput } from '@instructure/quiz-rce';
import { Button } from '@instructure/ui-buttons';
import { Heading } from '@instructure/ui-heading';
import AnswerInput from '../AnswerInput';
import AnswerPoints from '../AnswerPoints';
import LockChoiceButton from '../LockChoiceButton';
import RemoveChoiceButton from '../RemoveChoiceButton';
import EditAnswerFeedbackButton from '../EditAnswerFeedbackButton';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import t from '@instructure/quiz-i18n/format-message';
var ChoiceInput = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_ChoiceInput = /*#__PURE__*/function (_Component) {
  function ChoiceInput() {
    var _this2;
    _classCallCheck(this, ChoiceInput);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, ChoiceInput, [].concat(args));
    _defineProperty(_this2, "removeChoicebutton", null);
    _defineProperty(_this2, "answerInput", null);
    _defineProperty(_this2, "lockChoiceButton", null);
    _defineProperty(_this2, "editAnswerFeedbackButton", null);
    _defineProperty(_this2, "answerFeedbackInput", null);
    // ================
    //   PUBLIC UTILS
    // ================
    _defineProperty(_this2, "focusOnRemoveChoice", function () {
      _this2.removeChoicebutton.focus();
    });
    _defineProperty(_this2, "focusOnAnswerInput", function () {
      _this2.answerInput.focus();
    });
    _defineProperty(_this2, "focusOnAnswerFeedback", function () {
      if (_this2.editAnswerFeedbackButton) {
        _this2.editAnswerFeedbackButton.focus();
      }
    });
    _defineProperty(_this2, "focusLast", function () {
      if (_this2.props.shouldRenderRemoveChoice) {
        _this2.removeChoicebutton.focus();
      } else if (_this2.props.showLock) {
        _this2.lockChoiceButton.focus();
      } else {
        _this2.answerInput.focus();
      }
    });
    _defineProperty(_this2, "focusAndCloseRCE", function () {
      _this2.focusOnAnswerFeedback();
      _this2.props.handleAnswerFeedbackToggle(_this2.props.id);
    });
    // ============
    //   HANDLERS
    // ============
    _defineProperty(_this2, "handleEditAnswerFeedbackRef", function (node) {
      _this2.editAnswerFeedbackButton = node;
    });
    _defineProperty(_this2, "handleRemoveChoiceButtonRef", function (node) {
      _this2.removeChoicebutton = node;
    });
    _defineProperty(_this2, "handleAnswerInputRef", function (node) {
      _this2.answerInput = node;
    });
    _defineProperty(_this2, "handleLockButtonRef", function (node) {
      _this2.lockChoiceButton = node;
    });
    _defineProperty(_this2, "handleRichContentChange", function (event, rceContent) {
      var editorContent = rceContent.editorContent;
      if (editorContent === void 0) {
        return;
      }
      _this2.props.changeItemState({
        answerFeedback: Object.assign({}, _this2.props.answerFeedback, _defineProperty({}, _this2.props.id, editorContent))
      });
    });
    return _this2;
  }
  _inherits(ChoiceInput, _Component);
  return _createClass(ChoiceInput, [{
    key: "renderLockButton",
    value:
    // ===========
    //   RENDERS
    // ===========

    function renderLockButton() {
      var screenReaderText = this.props.isLocked ? t('Unlock Distractor Position: {choice}', {
        choice: striptags(this.props.itemBody)
      }) : t('Lock Distractor Position: {choice}', {
        choice: striptags(this.props.itemBody)
      });
      return jsx(LockChoiceButton, {
        ref: this.handleLockButtonRef,
        choiceId: this.props.id,
        isLocked: this.props.isLocked,
        onToggle: this.props.toggleChoiceLocked,
        disabled: this.props.disabledFields.includes('lockChoiceButton'),
        screenReaderText: screenReaderText
      });
    }
  }, {
    key: "renderRemoveChoiceButton",
    value: function renderRemoveChoiceButton() {
      var _this$props$slotProps;
      var _ref = ((_this$props$slotProps = this.props.slotProps) === null || _this$props$slotProps === void 0 ? void 0 : _this$props$slotProps.removeChoiceButton) || {},
        inputRef = _ref.inputRef,
        screenReaderText = _ref.screenReaderText,
        onRemoveChoice = _ref.onRemoveChoice,
        slotProps = _objectWithoutProperties(_ref, _excluded);
      var text = screenReaderText || this.props.removeButtonScreenReaderText || t('Remove Distractor: {choice}', {
        choice: striptags(this.props.itemBody)
      });
      var onRemoveChoiceFunction = onRemoveChoice || this.props.onRemoveChoice;
      var ref = inputRef || this.handleRemoveChoiceButtonRef;
      return jsx(RemoveChoiceButton, Object.assign({
        ref: ref,
        screenReaderText: text,
        onRemoveChoice: onRemoveChoiceFunction
      }, slotProps, {
        choiceId: this.props.id,
        automationData: "sdk-remove-".concat(this.props.id, "-button")
      }));
    }
  }, {
    key: "renderEditAnswerFeedbackButton",
    value: function renderEditAnswerFeedbackButton() {
      return jsx(EditAnswerFeedbackButton, {
        ref: this.handleEditAnswerFeedbackRef,
        choiceId: this.props.id,
        onEditChoiceFeedback: this.props.handleAnswerFeedbackToggle,
        iconFilled: !!this.props.answerFeedback[this.props.id],
        itemBody: this.props.itemBody,
        expanded: this.props.expanded,
        notifyScreenreader: this.props.notifyScreenreader,
        automationData: "sdk-choice-edit-answer-feedback-button"
      });
    }
  }, {
    key: "renderAnswerPoints",
    value: function renderAnswerPoints() {
      return jsx(AnswerPoints, {
        name: "".concat(this.props.id, "_answerPoints"),
        answerPoints: this.props.answerPoints,
        onAnswerPointsChange: this.props.onAnswerPointsChange
      });
    }
  }, {
    key: "renderBeforeComponent",
    value: function renderBeforeComponent() {}
  }, {
    key: "renderAnswerFeedbackInput",
    value: function renderAnswerFeedbackInput() {
      var rceId = "".concat(this.props.id, "_answer_feedback");
      return jsx(Flex, {
        direction: "column",
        "data-automation": "sdk-choice-edit-answer-feedback-rce"
      }, jsx(Heading, {
        level: "h4",
        as: "h3",
        margin: "medium 0 xxx-small"
      }, t('Answer Feedback')), jsx(RichContentInput, {
        label: jsx(ScreenReaderContent, null, t('Edit choice feedback')),
        plainTextLabel: t('Edit choice feedback'),
        onChange: this.handleRichContentChange,
        onKeyUp: this.handleRichContentChange,
        onModalClose: this.props.onModalClose,
        onModalOpen: this.props.onModalOpen,
        openImportModal: this.props.openImportModal,
        placeholder: t('Edit choice feedback'),
        defaultContent: this.props.answerFeedback[this.props.id],
        textareaId: rceId
      }), jsx("div", {
        css: this.props.styles.doneButton
      }, jsx(Button, {
        onClick: this.focusAndCloseRCE,
        margin: "small",
        "data-automation": "sdk-edit-answer-feedback-done-button"
      }, t('Done'))));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        expanded = _this$props.expanded,
        itemBody = _this$props.itemBody,
        errors = _this$props.errors,
        id = _this$props.id,
        renderBeforeComponent = _this$props.renderBeforeComponent,
        shouldRenderAnswerPoints = _this$props.shouldRenderAnswerPoints,
        showLock = _this$props.showLock,
        shouldRenderRemoveChoice = _this$props.shouldRenderRemoveChoice,
        shouldRenderAnswerFeedback = _this$props.shouldRenderAnswerFeedback;
      var screenreaderText = t('Answer Value {itemBody}', {
        itemBody: striptags(itemBody)
      });
      return jsx(Grid, {
        rowSpacing: "small",
        colSpacing: "small"
      }, jsx(Grid.Row, null, renderBeforeComponent && jsx(Grid.Col, {
        width: "auto"
      }, jsx(View, {
        as: "div",
        margin: "xx-large 0 0 0",
        themeOverride: {
          marginXxLarge: '39px'
        }
      }, this.props.renderBeforeComponent)), jsx(Grid.Col, null, jsx(Flex, {
        direction: "column",
        gap: "small"
      }, jsx(Flex.Item, null, jsx(AnswerInput, {
        disabled: this.props.disabledFields.includes('answerInput'),
        errors: errors,
        id: id,
        itemBody: itemBody,
        focusOnMount: this.props.focusOnMount,
        noRCE: this.props.noRCE,
        onChangeHandler: this.props.onInputChange,
        onBlurHandler: this.props.onInputBlur,
        onModalClose: this.props.onModalClose,
        onModalOpen: this.props.onModalOpen,
        openImportModal: this.props.openImportModal,
        parentType: this.props.parentType,
        renderLabel: this.props.renderLabel,
        isRequired: this.props.isRequired,
        readOnly: this.props.readOnlyFields.includes('answerInput'),
        ref: this.handleAnswerInputRef,
        screenReaderText: this.props.screenReaderText || screenreaderText,
        automationData: this.props.automationData
      })), expanded && shouldRenderAnswerFeedback && jsx(Flex.Item, null, this.renderAnswerFeedbackInput()))), jsx(Grid.Col, {
        width: "auto"
      }, jsx(View, {
        as: "div",
        height: "100%",
        margin: "xx-large 0 0 0",
        themeOverride: {
          marginXxLarge: '30px'
        }
      }, jsx(Flex, {
        direction: "row",
        alignItems: "start"
      }, shouldRenderAnswerPoints && this.renderAnswerPoints(), showLock && this.renderLockButton(), shouldRenderAnswerFeedback && this.renderEditAnswerFeedbackButton(), shouldRenderRemoveChoice && this.renderRemoveChoiceButton())))));
    }
  }]);
}(Component), _defineProperty(_ChoiceInput, "displayName", 'ChoiceInput'), _defineProperty(_ChoiceInput, "componentId", "Quizzes".concat(_ChoiceInput.displayName)), _defineProperty(_ChoiceInput, "propTypes", {
  answerFeedback: PropTypes.objectOf(PropTypes.string),
  answerPoints: PropTypes.number,
  changeItemState: PropTypes.func,
  disabledFields: PropTypes.arrayOf(PropTypes.string),
  errors: PropTypes.array,
  expanded: PropTypes.bool,
  focusOnMount: PropTypes.bool,
  handleAnswerFeedbackToggle: PropTypes.func,
  id: PropTypes.string.isRequired,
  isLocked: PropTypes.bool,
  itemBody: PropTypes.string.isRequired,
  noRCE: PropTypes.bool,
  notifyScreenreader: PropTypes.func.isRequired,
  onAnswerPointsChange: PropTypes.func,
  onInputChange: PropTypes.func.isRequired,
  onInputBlur: PropTypes.func,
  onModalClose: PropTypes.func,
  onModalOpen: PropTypes.func,
  onRemoveChoice: PropTypes.func,
  parentType: PropTypes.string,
  renderLabel: PropTypes.string,
  renderBeforeComponent: PropTypes.any,
  shouldRenderAnswerPoints: PropTypes.bool,
  shouldRenderAnswerFeedback: PropTypes.bool,
  shouldRenderRemoveChoice: PropTypes.bool,
  showLock: PropTypes.bool,
  toggleChoiceLocked: PropTypes.func,
  openImportModal: PropTypes.func,
  readOnlyFields: PropTypes.arrayOf(PropTypes.string),
  removeButtonScreenReaderText: PropTypes.string,
  screenReaderText: PropTypes.string,
  styles: PropTypes.object,
  automationData: PropTypes.string,
  isRequired: PropTypes.bool,
  slotProps: PropTypes.shape({
    removeChoiceButton: PropTypes.object
  })
}), _defineProperty(_ChoiceInput, "defaultProps", {
  answerFeedback: {},
  changeItemState: function changeItemState() {},
  disabledFields: [],
  errors: [],
  expanded: false,
  focusOnMount: false,
  handleAnswerFeedbackToggle: function handleAnswerFeedbackToggle() {},
  noRCE: false,
  parentType: '',
  renderLabel: void 0,
  readOnlyFields: [],
  renderBeforeComponent: null,
  shouldRenderAnswerPoints: false,
  shouldRenderAnswerFeedback: false,
  shouldRenderRemoveChoice: false,
  answerPoints: void 0,
  isLocked: void 0,
  onAnswerPointsChange: void 0,
  onInputBlur: function onInputBlur() {},
  onModalClose: void 0,
  onModalOpen: void 0,
  onRemoveChoice: void 0,
  showLock: void 0,
  toggleChoiceLocked: void 0,
  openImportModal: void 0,
  removeButtonScreenReaderText: void 0,
  screenReaderText: void 0,
  automationData: '',
  isRequired: false
}), _ChoiceInput)) || _class);
export { ChoiceInput as default };